const CheckedLargeIcon = ({ color = 'currentColor' }) => {
  return (
    <svg
      width="64"
      height="46"
      viewBox="0 0 64 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M59.5057 4.19238L21.3793 42.3188L4.04907 24.9886"
        stroke={color}
        strokeWidth="7.10983"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CheckedLargeIcon;
